import { parseNumeric } from "../../../helpers";

export const CantidadColumn = ({ cantidad, unidadmedida_nombre }) => {
  return (
    <>
      <b>
        {parseNumeric(cantidad).toFixed(2)}
        <small> {unidadmedida_nombre}</small>
      </b>
    </>
  );
};
